<template>
  <header class="header">
    <div class="header__content">
      <div class="header__content__logo">
        <router-link :to="homePath">
          <img src="../../assets/logo.svg" alt="logo" />
        </router-link>
      </div>

      <app-menu
        v-if="isControls"
        class="header__menu"
        :navigations="navigations"
      />

      <div v-if="isControls" class="header__info">
        <language-switch @switchGbr="switchGbr" @switchRus="switchRus" />
        <app-avatar
          class="header__info__item"
          :name="userName"
          :photo="avatarPhoto"
        />
        <div class="header__info__item header__info__exit" @click="onExit">
          <i class="el-icon-switch-button"></i>
          {{ $t("header_exit") }}
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import AppMenu from "../library.blocks/AppMenu.vue";
import AppAvatar from "../library.blocks/AppAvatar.vue";
import LanguageSwitch from "../library.blocks/LanguageSwitch.vue";

import {
  LOGOUT,
  ATTRIBUTE_TEMPLATES_CLEAR,
  OBJECTS_ANY_PARAMS_CLEAR,
  OBJECTS_LIST_CLEAR,
  OBJECTS_CLEAR,
  OBJECTS_COPY_CLEAR,
  OBJECT_TEMPLATES_CLEAR,
  OBJECT_TYPES_CLEAR,
  REFERENCE_CLEAR
} from "@/store/type";
import { AUTH, HOME, SETTINGS /*, TOURS*/ } from "@/router/type";
import { allowedForRole, isAdmin } from "@/router/utils";
import { RUS, GBR } from "@/domain/locales.types";

import { mapState } from "vuex";

export default {
  name: "TheHeading",
  props: {},
  components: {
    AppMenu,
    AppAvatar,
    LanguageSwitch
  },
  computed: {
    ...mapState({
      userName: state => state.users.login,
      isControls: state => state.users.isUsedToken,
      auth: state => state.users.auth,
      lang: state => state.settings.lang
    }),
    navigations() {
      let router = this.$router.options.routes;
      return [
        { path: HOME, name: this.$t("header_nav_objects") },
        {
          path: SETTINGS,
          name: this.$t("header_nav_settings"),
          params: [{ type: "object_template" }]
        }
      ].filter(p => {
        return allowedForRole(router, p.path, this.auth);
      });
    },
    avatarPhoto() {
      return isAdmin(this.auth)
        ? "/img/squirrel.jpg"
        : "/img/squirrel_white.jpg";
    },
    homePath() {
      return HOME;
    }
  },
  methods: {
    clearAllState() {
      this.$store.commit(ATTRIBUTE_TEMPLATES_CLEAR);
      this.$store.commit(OBJECTS_LIST_CLEAR);
      this.$store.commit(OBJECTS_CLEAR);
      this.$store.commit(OBJECTS_COPY_CLEAR);
      this.$store.commit(OBJECTS_ANY_PARAMS_CLEAR);
      this.$store.commit(OBJECT_TEMPLATES_CLEAR);
      this.$store.commit(OBJECT_TYPES_CLEAR);
      this.$store.commit(REFERENCE_CLEAR);
      this.$store.commit("clearObjectComplexValue");
      this.$store.commit("clearTextEditorText");
      this.$store.commit("clearFileUploader");
      this.$store.commit("clearPictureEditor");
    },
    onExit() {
      this.clearAllState();
      this.$store.commit(LOGOUT);
      this.$router.push(AUTH);
    },
    switchRus() {
      if (this.lang !== RUS) {
        this.clearAllState();
        this.$store.commit("setSettingsLanguage", RUS);
        this.$router.go(this.$router.currentRoute);
      }
    },
    switchGbr() {
      if (this.lang !== GBR) {
        this.clearAllState();
        this.$store.commit("setSettingsLanguage", GBR);
        this.$router.go(this.$router.currentRoute);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.header {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  background-color: $company_color;
  color: $header_text_color;

  .header__content {
    max-width: $content_weight;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
  }

  .header__content__logo {
    width: 20%;

    img {
      width: 60%;
      vertical-align: middle;
    }
  }

  .header__menu {
    width: 50%;
    height: 100%;
  }

  .header__info {
    width: 30%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: flex-end;

    .header__info__item {
      padding-left: $component_padding_on_left;
    }

    .header__info__item:first-child {
      padding-left: 0;
    }

    .header__info__exit:hover {
      cursor: pointer;
      color: $primary_color;
    }
  }
}
</style>
